<template>
  <div class="mx-4 px-3 pt-5">
    <h2 xs8 sm8 md8>Condition Report: {{ processedArtwork.title }}</h2>
    <v-flex xs4 sm4 md4 mb-3>
      <!-- <v-switch
        v-model="autosave"
        label="Autosave"
        color="success"
        hide-details
      ></v-switch> -->
    </v-flex>
    <v-stepper v-model="e1" red color="black" class="elevation-1">
      <v-stepper-header>
        <v-stepper-step :complete="e1 > 1" step="1" color="black"
          >Select Artwork
        </v-stepper-step>
        <!-- <v-divider></v-divider> -->
        <v-stepper-step :complete="e1 > 2" step="2" color="black">
          Artwork Details</v-stepper-step
        >
        <!-- <v-divider></v-divider> -->
        <v-stepper-step :complete="e1 > 3" step="3" color="black">
          Storage/Handling</v-stepper-step
        >
        <!-- <v-divider></v-divider> -->
        <v-stepper-step :complete="e1 > 4" step="4" color="black">
          Diagnosis</v-stepper-step
        >
        <!-- <v-divider></v-divider> -->
        <v-stepper-step :complete="e1 > 5" step="5" color="black">
          General</v-stepper-step
        >
        <v-stepper-step :complete="e1 > 6" step="6" color="black">
          Conservation</v-stepper-step
        >
        <v-stepper-step :complete="e1 > 7" step="7" color="black"
          >Photos</v-stepper-step
        >
        <v-stepper-step step="8">Download PDF</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card class="elevation-0 mb-5">
            <v-container fluid>
              <v-layout row wrap>
                <!-- <v-flex xs12 sm6>
                  <v-subheader v-text="'Select Artwork fro CR'"></v-subheader>
                </v-flex> -->
                <v-flex xs12 sm12>
                  <v-autocomplete
                    :items="artworks"
                    v-model="selected_artwork"
                    item-text="title"
                    item-value="id"
                    label="Select Artwork"
                    @input="getArtwork(selected_artwork)"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>

            <div v-if="processedArtwork" class="ml-3">
              <v-img
                width="150px"
                xs4
                sm6
                class="white--text"
                v-if="processedArtwork.top_photo_id > 0"
                v-bind:src="
                  'https://api.tb-cms.org/data/artwork/' +
                  processedArtwork.id +
                  '/' +
                  processedArtwork.top_photo_id +
                  '_th.jpg'
                "
                height="150px"
              >
                <!-- <v-container fill-height fluid>
                  <v-layout fill-height>
                    <v-flex xs12 align-end flexbox>
                      <span class="small">{{processedArtwork.credit}} test credit</span>
                    </v-flex>
                  </v-layout>
                </v-container> -->
              </v-img>
              <v-card-title primary-title>
                <div>
                  <h3 class="headline mb-0">{{ processedArtwork.title }}</h3>
                  <div>
                    {{ processedArtwork.accession_number }} <br />
                    {{ processedArtist.name }}<br />
                    <!-- Credit: {{processedArtwork.credit}}<br> -->
                    Edition: {{ processedArtwork.edition_state }}<br />
                    Signature: {{ processedArtwork.signature_new }}<br />
                    Dimensions: {{ this.selected_artwork.dim_f_json }}<br />
                    Packings: {{ processedArtwork.packings }}<br />
                    Crate details: {{ processedArtwork.crate_details }}<br />
                  </div>
                </div>
              </v-card-title>
              <v-card-actions>
                <v-checkbox
                  class="ml-2"
                  color="black"
                  label="Yes, this is the one"
                  v-model="approved"
                ></v-checkbox>
                <!-- <v-checkbox
                  label="Settings 1"
                  v-model="settings1"
                ></v-checkbox>
                <v-checkbox
                  label="Settings 2"
                  v-model="settings2"
                ></v-checkbox>
                <v-checkbox
                  label="Settings 3"
                  v-model="settings3"
                ></v-checkbox>
                <v-checkbox
                  label="Settings 4"
                  v-model="settings4"
                ></v-checkbox> -->
                <!-- <v-btn flat color="orange">Share</v-btn>
                <v-btn flat color="orange">Explore</v-btn> -->
              </v-card-actions>
            </div>
          </v-card>

          <v-btn :disabled="!approved" flat black @click.native="e1 = 2"
            >Next</v-btn
          >
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card class="mb-5 elevation-0">
            <!-- <v-card-title>Artwork Details</v-card-title> -->
            <v-container fluid>
              <v-expansion-panel focusable>
                <v-expansion-panel-content :key="1">
                  <div slot="header">Artwork Type</div>
                  <v-card>
                    <v-card-text class="grey lighten-4">
                      <!-- <v-flex xs6>
                          <v-subheader>Artwork Type</v-subheader>
                        </v-flex> -->
                      <v-flex xs6>
                        <v-radio-group v-model="artwork_type">
                          <v-radio label="Drawing" value="1"></v-radio>
                          <v-radio label="Painting" value="2"></v-radio>
                          <v-radio label="Photo | Print" value="3"></v-radio>
                          <v-radio label="Sculpture" value="4"></v-radio>
                          <v-radio
                            label="Audio/Visual Installation"
                            value="5"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content :key="2">
                  <div slot="header">Dimensions</div>
                  <v-card>
                    <v-card-text class="grey lighten-4">
                      <!-- <v-flex xs6>
                          <v-subheader>Artwork Type</v-subheader>
                        </v-flex> -->
                      <v-flex xs12>
                        <v-textarea
                          name="input-1"
                          label="Dimension Details"
                          auto-grow
                          class="mx-2 my-3"
                          rows="1"
                        ></v-textarea>
                      </v-flex>

                      <v-flex xs12>
                        <v-textarea
                          name="input-1"
                          label="Description background of origin / Production process"
                          auto-grow
                          class="mx-2 my-3"
                          rows="1"
                        ></v-textarea>
                      </v-flex>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>

                <v-expansion-panel-content :key="3">
                  <div slot="header">Components</div>
                  <v-card>
                    <v-card-text class="grey lighten-4">
                      <!-- NO COMPONENTS FOR THIS ARTWORK ENTERED<br><br>
                        - Components Electrical (from CMS Advanced/Media Details/Description), Specification<br>
                        - Components Electrical (from CMS Advanced/Media Details/Description), Origin<br>
                        - Components Non-electrical (from CMS Advanced/Media Details/Description)<br>
                        - Components Tools & Gear (from CMS Advanced/Media Details/Description)<br>
                        - Components Other (from CMS Advanced/Media Details/Description) -->
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-container>
          </v-card>
          <v-btn flat black @click.native="e1 = 1">Back</v-btn>
          <v-btn flat black @click.native="e1 = 3">Save and Continue</v-btn>
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card class="mb-5 elevation-0">
            <v-card-text>
              <!-- <v-subheader>Description of Condition</v-subheader> -->
              <v-container fluid>
                <v-expansion-panel focusable>
                  <v-expansion-panel-content :key="1">
                    <div slot="header">1. Storage</div>
                    <v-flex xs12 class="pl-3 pr-3">
                      <v-textarea
                        auto-grow
                        name="input-1"
                        class="mx-2 my-3"
                        label="Current packing material"
                        rows="1"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Packed Dimensions"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Special Storage conditions"
                      ></v-textarea>
                    </v-flex>
                  </v-expansion-panel-content>

                  <v-expansion-panel-content :key="2">
                    <div slot="header">2. Handling and transportation</div>
                    <v-flex xs12 class="pl-3 pr-3">
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Handling Requirements"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Pay particular attention to"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Instructions for transportation"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Method of handling of artwork"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Courier / Assistant recommended"
                      ></v-textarea>
                    </v-flex>
                  </v-expansion-panel-content>

                  <v-expansion-panel-content :key="3">
                    <div slot="header">3. Exhibition conditions</div>
                    <v-flex xs12 class="pl-3 pr-3">
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Requirements during exhibition"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Special exhibition condition"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Special maintenance during exhibitions"
                      ></v-textarea>
                      <v-textarea
                        auto-grow
                        name="input-1"
                        rows="1"
                        class="mx-2 my-3"
                        label="Regular inspection of possible changes during exhibition"
                      ></v-textarea>
                    </v-flex>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-container>
            </v-card-text>
          </v-card>
          <v-btn color="primary" @click.native="e1 = 2">Back</v-btn>
          <v-btn color="primary" @click.native="e1 = 4"
            >Save and Continue</v-btn
          >
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card class="mb-5 elevation-0">
            <v-card-text>
              <v-container fluid>
                <v-expansion-panel focusable>
                  <v-expansion-panel-content :key="1">
                    <div slot="header">1. Description of Condition</div>
                    <v-flex xs12 pl-4 pr-4>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Description of Condition"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                  </v-expansion-panel-content>

                  <v-expansion-panel-content :key="2">
                    <div slot="header">2. Damage Category</div>
                    <v-flex xs12 pl-4 pr-3>
                      <v-checkbox
                        v-for="d in damage_types"
                        small
                        v-bind:key="d"
                        v-model="damage_categories"
                        v-bind:label="d"
                        v-bind:value="d"
                        hide-details
                        class="xs4 left mr-2"
                        style="width: 280px"
                        >{{ d }}</v-checkbox
                      >
                    </v-flex>
                  </v-expansion-panel-content>

                  <v-expansion-panel-content :key="3">
                    <div slot="header">3. Damage</div>
                    <v-flex xs12 pl-4 pr-4>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Type of Damage"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Visual Illustration"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Preliminary examination"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Material-technical options"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Weighing the options for conservation"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="Preventive conservation/minimal conservation requirements"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="No conservation/restoration required"
                        auto-grow
                      ></v-textarea>
                      <v-textarea
                        rows="1"
                        class="mx-2 my-3"
                        name="input-1"
                        label="No conservation/restoration possible"
                        auto-grow
                      ></v-textarea>
                    </v-flex>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-container>
            </v-card-text>
          </v-card>
          <v-btn color="primary" @click.native="e1 = 3">Back</v-btn>
          <v-btn color="primary" @click.native="e1 = 5">Continue</v-btn>
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-card class="mb-3 pl-3 pr-3 elevation-0">
            <v-textarea
              name="input-1"
              label="General Condition Notes"
              class="pt-4"
              auto-grow
            ></v-textarea>
            <v-checkbox
              label="Issues are inharent"
              v-model="inharent"
            ></v-checkbox>

            <v-select
              :items="[
                'Excellent',
                'Very Good',
                'Good',
                'Fair',
                'Poor',
                'Very Poor',
              ]"
              v-model="condition_category"
              label="General Condition Category"
              single-line
            ></v-select>
            <v-text-field
              id="examined_by"
              name="input-1"
              label="Examined by"
            ></v-text-field>
            <v-text-field
              id="examiner_title"
              name="input-1"
              label="Examiner Title"
            ></v-text-field>
            <v-text-field
              id="eamination_location"
              name="input-1"
              label="Examination Location"
            ></v-text-field>
            <v-menu
              ref="menu"
              :close-on-content-click="false"
              v-model="menu"
              :nudge-right="40"
              :return-value.sync="date"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="date"
                label="Examination Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="date" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menu.save(date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>
            <v-text-field
              slot="activator"
              v-model="examination_reason"
              label="Reason for Examination"
            ></v-text-field>
          </v-card>

          <v-btn flat black @click.native="e1 = 4">Back</v-btn>
          <v-btn flat black @click.native="e1 = 6">Save and Continue</v-btn>
          <v-btn flat black>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="6">
          <v-card class="mb-3 pl-3 pr-3 elevation-0">
            <h3 class="sub-headline pt-3">Diagnosis and Proposal</h3>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Description of Condition / Type of Damage"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Concept (and planning) of Conservation"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Conservation required"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="General Condition Category"
            ></v-textarea>
            <h3 class="sub-headline pt-3">Treatment</h3>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Parts / Action"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="List of products used (brand names etc)"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Cleaning"
            ></v-textarea>
            <h3 class="sub-headline pt-3">Packing and Handling</h3>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Storage Conditions"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Art Handling | Transport"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Exhibition Conditions"
            ></v-textarea>
            <h3 class="sub-headline pt-3">Comments and Notes</h3>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Assessment of Greatest Risks"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Conservator's Comments"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Literature"
            ></v-textarea>
            <h3 class="sub-headline pt-3">History</h3>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Examined by"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Examiner Title"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Examination Date"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Examination Location"
            ></v-textarea>
            <v-textarea
              name="input-1"
              class="pt-2"
              auto-grow
              rows="1"
              label="Reason for Examination"
            ></v-textarea>

            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <edit-field
                  v-for="field in fields_conservation"
                  v-show="!field.dynamic"
                  :id="field.name"
                  :name="field.name"
                  :class="
                    'flex ' +
                    (field.class ? field.class : 'xs12') +
                    (field.dynamic ? ' red lighten-5' : '')
                  "
                  :artwork="processedArtwork"
                  :field="field"
                  :fields_parent="fields_conservation"
                  :key="field.key"
                  :report="report"
                  @add_field="add_field"
                >
                </edit-field>
              </v-layout>
            </v-container>
          </v-card>

          <v-btn flat black @click.native="e1 = 5">Back</v-btn>
          <v-btn flat black @click.native="e1 = 7">Save and Continue</v-btn>
          <v-btn flat black>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="7">
          <v-card class="mb-5 pl-3 pr-3 pb-3 elevation-0">
            <v-flex xs12 sm12 md12
              ><br />
              <h3 class="title mb-3">Upload photos</h3>
              <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
            </v-flex>
          </v-card>
          <v-btn flat black @click.native="e1 = 6">Back</v-btn>
          <v-btn flat black @click.native="e1 = 8">Save</v-btn>
          <v-btn flat black>Cancel</v-btn>
        </v-stepper-content>

        <v-stepper-content step="8">
          <v-card class="mb-5 pl-3 pr-3 pb-3 elevation-0">
            <v-flex xs12 sm12 md12
              ><br />
              <h3 class="title mb-3">Download Report</h3>
              <v-btn color="primary" @click.native="pdf">Full PDF </v-btn>
            </v-flex>
          </v-card>
          <v-btn flat black @click.native="e1 = 6">Back</v-btn>
          <v-btn flat black @click.native="e1 = 8">Save</v-btn>
          <v-btn flat>Cancel</v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import axios from 'axios'
import EditField from '@/components/artworks/EditField'
// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  data() {
    return {
      report: {
        date: '',
      },
      fields_conservation: [
        // {
        //   name: 'diagnosis_and_proposal',
        //   headline: true,
        //   title: 'Diagnosis and Proposal',
        //   section: 'diagnosis',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'text-long',
        //   name: 'accession_number',
        //   title: 'Description of Condition / Type of Damage',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   ctype: 'text-long',
        //   name: 'accession_number2',
        //   title: 'Concept (and planning) of Conservation',
        //   dynamic: true,
        //   section: 'diagnosis',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },

        {
          name: 'media_details',
          headline: true,
          title: 'Reading Devices',
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'computer',
          title: 'Computer',
          dynamic: true,
          section: 'media_details',
          selection: ['Server', 'Laptop', 'Desktop', 'Virtual', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'micro_controller',
          title: 'Micro Controller',
          dynamic: true,
          section: 'media_details',
          selection: ['LCD', 'LED-LCD', 'Plasma', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'film_projector',
          title: 'Film Projector',
          dynamic: true,
          section: 'media_details',
          selection: ['8 mm', '16mm', '35mm', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'slide_projector',
          title: 'Slide Projector',
          dynamic: true,
          section: 'media_details',
          selection: ['Single projecting', 'Slate', 'Carousel', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'video_tape_recorder',
          title: 'Video Tape Recorder',
          dynamic: true,
          section: 'media_details',
          selection: [
            'Open Reel (1/2“)',
            'Umatic',
            'Betacam/SP',
            'VHS',
            'Digital Betacam',
            'DV  (1/4“)',
            'HDCAM',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'bool',
          name: 'linear_tape_drive',
          title: 'Linear Tape Drive',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'bool',
          name: 'floppy',
          title: 'Disc Tape Drive (Floppy)',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'bool',
          name: 'dvd_player',
          title: 'DVD Player',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'bool',
          name: 'media_player',
          title: 'Media player',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'other_player',
          title: 'Other',
          dynamic: true,
          section: 'media_details',
          selection: ['Server', 'Laptop', 'Desktop', 'Virtual', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'brand',
          title: 'Brand',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'type_and_model',
          title: 'Type and Model',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'date',
          name: 'production_date_new',
          title: 'Date of Production',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'checkbox',
          name: 'interfaces',
          title: 'Interfaces',
          dynamic: true,
          section: 'media_details',
          selection: [
            'composite',
            'component',
            'SVideo',
            'SDI',
            'VGA',
            'HDMI',
            'DVI',
            'IDE',
            'SATA',
            'USB 2.0',
            'USB 3.0',
            'FireWire',
            'Thunderbolt',
            'XLR Audio',
            'unknown',
            'other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'input_output',
          title: 'Input - Output',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-short',
          name: 'power-requirement',
          title: 'Power Requirement',
          dynamic: true,
          class: 'xs12 md6',
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'cooling_system',
          title: 'Cooling system',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-short',
          name: 'number_of_parts',
          title: 'Number of Parts',
          dynamic: true,
          section: 'media_details',
          class: 'xs12 md6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'specification_of_parts',
          title: 'Specification of parts',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'dimensions',
          title: 'Dimensions (cm) and weight',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'modification',
          title: 'Modification',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'installation_specification',
          title: 'Specifications on installation',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'peripherals',
          title: 'Peripherals',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'associated_items',
          title: 'Associated items',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'provided_spare_parts',
          title: 'Provided spare parts',
          dynamic: true,
          section: 'media_details',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },

        {
          name: 'conservation',
          headline: true,
          title: 'Conservation',
          section: 'conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'appearance',
          title: 'Appearance',
          dynamic: true,
          section: 'conservation',
          selection: ['Good', 'Acceptable', 'Poor'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'other',
          title: 'Other',
          dynamic: true,
          section: 'conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'operation',
          title: 'Operation',
          dynamic: true,
          section: 'conservation',
          selection: [
            'Working properly',
            'Pretend to work properly',
            'Not working at all',
            'Not sure',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'troubleshooting',
          title: 'Troubleshooting',
          dynamic: true,
          section: 'conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        // {
        //   ctype: 'text-long',
        //   name: 'spare_parts_necessary',
        //   title: 'Spare Parts necessary',
        //   dynamic: true,
        //   section: 'conservation',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        {
          ctype: 'radio',
          name: 'treatment_report',
          title: 'Treatment Report',
          dynamic: true,
          section: 'conservation',
          selection: [
            'Material treatment',
            'Repaired parts',
            'Replaced parts',
            'Replaced device',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'maintenance_in_storage',
          title: 'Maintenance in Storage',
          dynamic: true,
          section: 'conservation',
          selection: [
            'Inspection regularly',
            'Testing – turning on and off regularly',
            'Other requirements',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'maintenance_in_exhibition',
          title: 'Maintenance in Exhibition',
          dynamic: true,
          section: 'conservation',
          selection: [
            'Inspection regularly',
            'Testing – turning on and off regularly',
            'Other requirements',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'spare_parts_necessary',
          title: 'Spare Parts necessary',
          dynamic: true,
          section: 'conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'provided_manuals',
          title: 'Provided manuals, warranty inf.',
          dynamic: true,
          section: 'conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'risk_of_obsolescence',
          title: 'Risk of Obsolescence',
          dynamic: true,
          section: 'conservation',
          selection: ['Still in manufacturing', 'Parts still available'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'are_replacements_possible',
          title: 'Are replacements possible',
          dynamic: true,
          section: 'conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },

        {
          name: 'information_carrier',
          headline: true,
          title: 'Information Carrier',
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'status',
          title: 'Status',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            "Artist's Original",
            'Master Physical',
            'Copy Master Physical',
            'Physical Access Copy',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'optical_film_type',
          title: 'Type - Optical Film',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            '8mm',
            '9,5mm',
            '16mm',
            '35mm',
            '70 mm',
            'slide',
            'negative small format',
            'medium format',
            'large format',
            'microfilm',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'optical_disc_type',
          title: 'Type - Optical Disc',
          dynamic: true,
          section: 'information_carrier',
          selection: ['Laser Disc', 'DVD', 'CD', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'mechanical_type',
          title: 'Type - Mechanical',
          dynamic: true,
          section: 'information_carrier',
          selection: ['vinyl record', 'punch card', '35mm', 'Other'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'magnetic_type',
          title: 'Type - Magnetic',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'Open Reel (1/2“)',
            'Umatic',
            'Betacam/SP',
            'VHS',
            'Digital Betacam',
            'DV  (1/4“)',
            'HDCAM',
            'Floppy',
            'external Hard Drive (HDD)',
            'LTO',
            'DLT',
            'DAT',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'electronical_type',
          title: 'Type - Electronical',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'USB',
            'Solid State Drive (SSD)',
            'Read Only Memory (ROM)',
            'Random Access Memory (RAM)',
            'EEPROM',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'unknown_type',
          title: 'Type - Unknown',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'other_type',
          title: 'Type - Other',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'material',
          title: 'Material',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'nitrate',
            'acetate',
            'polyester',
            'polycarbonate',
            'other polymer',
            'unknown',
            'glass',
            'metal',
            'paper',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-short',
          name: 'brand',
          title: 'Brand',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-short',
          name: 'model',
          title: 'Model',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'specifications',
          title: 'Specifications',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-short',
          name: 'length',
          title: 'Length (capacity)',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-short',
          name: 'size',
          title: 'Size',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'number_parts_series',
          title: 'Number I Parts I Series',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'associated_devices_to_read',
          title: 'Associated Devices to Read',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'signal_processing_video',
          title: 'Signal Processing Video',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'FBAS',
            'Y/C (S-Video I Dub)',
            'YCrCb (digital)',
            'YPbPr (analog)',
            'RGB',
            'unknown',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'signal_processing_audio',
          title: 'Signal Processing Audio',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'Optical',
            'Magnetic',
            'Longitudinal',
            'FM',
            'PCM',
            'Dolby',
            'unknown',
            'Other',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'generation_copy',
          title: 'Generation I Copy',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'Camera Negative',
            'Camera Positive',
            'Inter positive',
            'Inter negative',
            'Revearsal',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        // {
        //   ctype: 'date',
        //   name: 'production_date_new',
        //   title: 'Date of Production',
        //   dynamic: true,
        //   section: 'media_details',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        {
          ctype: 'text-long',
          name: 'specification_on_installation',
          title: 'Specification on Installation',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'shel_container_case',
          title: 'Shell | Container | Case',
          dynamic: true,
          section: 'information_carrier',
          selection: ['Signed by artist', 'Designed by artist', 'Non specific'],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'modifications',
          title: 'Modifications',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'installation_specifications',
          title: 'Specifications on Installation',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'radio',
          name: 'attached_documents',
          title: 'Attached documents',
          dynamic: true,
          section: 'information_carrier',
          selection: [
            'Certificate',
            'Dub sheet',
            'Vtr card',
            'Installation Instruction',
            'Contract',
            'Photos',
          ],
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'associated_periphals',
          title: 'Associated periphals',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
        {
          ctype: 'text-long',
          name: 'associated_items',
          title: 'Associated items',
          dynamic: true,
          section: 'information_carrier',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager'],
        },
      ],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 2.5,
        headers: { 'My-Awesome-Header': 'header value' },
      },
      success: false,
      condition_category: '',
      inharent: false,
      examined_by: '',
      examiner_title: '',
      eamination_location: '',
      examination_reason: '',
      selected_artwork: '',
      date: null,
      menu: false,
      modal: false,
      menu2: false,
      e1: 0,
      autosave: true,
      artwork_type: '',
      result: '',
      approved: true,
      settings1: false,
      settings2: false,
      settings3: false,
      settings4: false,
      damage_types: [
        'Abrasions Creases',
        'Tear',
        'Residue Discoloration Distortion Water damage Scratch',
        'Tape',
        'Fading',
        'Mould',
        'Flaking',
        'Cracking',
        'Dent',
        'Puncture',
        'Surface Dirt',
        'Loss / Missing Area Smudge',
        'Parasite',
        'Adhesive Residue Stains',
        'Warping',
        'Brittle Yellowed Sticky Dust',
      ].sort(),
      damage_categories: [],
    }
  },
  methods: {
    add_field(field) {
      // console.log('this[field]')
      // console.log(field)
      this[field['name']].show = true
    },
    saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTab', tab)
    },
    getArtwork(id) {
      // console.log(id)
      let url = `${this.$globals.apiserver}/artworks/${id}.json`
      // console.log(url)
      axios
        .get(url)
        .then((response) => {
          // this.loading = false;
          this.result = response.data
          // this.artwork = response.data
          // this.artist = response.data.artist
          // console.log(this.artist)
          // console.log(this.artwork)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    pdf() {
      // download PDF
    },
  },
  computed: {
    processedArtwork() {
      let processedArtwork = this.result
      return processedArtwork
    },
    processedArtist() {
      let processedArtist = this.result.artist
      return processedArtist
    },
    artworks() {
      return Object.assign([], this.$store.state.artworks)
    },
  },
  // vueDropzone: vue2Dropzone,
  components: {
    EditField,
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/reports/Wizzard.vue